import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { Modal } from '../components/Modal';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const NoParkingSpotsModal = observer(() => {
  const { t } = useTranslateFunction('parkinglayer');
  const { parking } = useStore();
  const [noParkingSpots, setNoParkingSpots] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [didLoad, setDidLoad] = useState(false);

  if (parking?.parkopedia?.parkingSpots?.status === 'loading' && !didLoad) {
    setDidLoad(true);
    // reset state on new request
    if (noParkingSpots) {
      setNoParkingSpots(false);
      setAccepted(false);
    }
  }
  // check for empty response if new request was made
  if (didLoad && parking?.parkopedia?.parkingSpots?.status === 'done') {
    setDidLoad(false);
    if (!parking.parkopedia.parkingSpots.data.length && !noParkingSpots) {
      setNoParkingSpots(true);
    }
  }

  return (
    <Modal
      icon="gys-eatdrink-restaurant-pizza"
      headline={t('no_Parking_spots_title')}
      content={t('no_Parking_spots_text')}
      className="no-scrollbar"
      acceptAction={() => {
        setAccepted(true);
      }}
      acceptText={t('button_ok')}
      isOpen={noParkingSpots && !accepted}
    />
  );
});
